export const calcColumnWidth = (
  windowWidth: number,
  componentSizes: IEventAreaCalc,
  amountOfColumns: number,
) =>
  (windowWidth -
    (componentSizes.sideNavWidth + componentSizes.hourColumnWidth)) /
  amountOfColumns
